// Crowd-data REQUEST deliverable validity.
//
// A completed request's sourced document is downloadable for one week from
// delivery. The backend returns `deliverableExpiresAt` (unix seconds) on the
// order/record; this turns it into a human "Valid for N days / hours" label and
// an expired flag for the download UI. See the crowd-data-request deliverable
// flow (jaaga-1 app/modules/property/crowddatarequest/deliverable.js).

/**
 * @param {number|null|undefined} expiresAtUnix - unix seconds, or null when the
 *   record predates the one-week window (then validity is unknown → no badge).
 * @returns {{ known: boolean, expired: boolean, label: string, seconds: number }}
 *   `known` is false when there's no expiry info (render nothing);
 *   `label` is e.g. "Valid for 6 days" / "Valid for 3 hours" / "Link expired".
 */
export function deliverableValidity(expiresAtUnix) {
  if (!expiresAtUnix) {
    return { known: false, expired: false, label: "", seconds: 0 };
  }
  const seconds = Math.floor(expiresAtUnix - Date.now() / 1000);
  if (seconds <= 0) {
    return { known: true, expired: true, label: "Link expired", seconds: 0 };
  }
  return {
    known: true,
    expired: false,
    label: `Valid for ${humanizeDuration(seconds)}`,
    seconds,
  };
}

/** "6 days" / "3 hours" / "45 minutes" / "under a minute" (largest unit only). */
function humanizeDuration(seconds) {
  const day = 86400;
  const hour = 3600;
  const minute = 60;
  if (seconds >= day) {
    const n = Math.floor(seconds / day);
    return `${n} ${n === 1 ? "day" : "days"}`;
  }
  if (seconds >= hour) {
    const n = Math.floor(seconds / hour);
    return `${n} ${n === 1 ? "hour" : "hours"}`;
  }
  if (seconds >= minute) {
    const n = Math.floor(seconds / minute);
    return `${n} ${n === 1 ? "minute" : "minutes"}`;
  }
  return "under a minute";
}
